import React, { ReactNode, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { KitFlexCol, KitFlexRow } from './KitFlexbox';
import KitIcon from './KitIcon';
import constants from '../common/theme/constants';

const VerticalLeftBorder = styled.div`
  border-left: ${constants.border.width}px solid ${({ theme }) => theme.timeline.line};
  margin-left: 9px;
  margin-bottom: ${constants.spacing.absolute.xs}px;
  margin-top: ${constants.spacing.absolute.xs}px;
  height: 100%;
`;

const Timestamp = styled.div`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.bold};
  font-size: ${constants.fontSize.p}rem;
  color: ${({ theme }) => theme.timeline.time};
`;

const Description = styled.div`
  color: ${({ theme }) => theme.timeline.description};
  padding-top: ${constants.spacing.absolute.xs}px;
  padding-bottom: ${constants.spacing.absolute.m}px;
`;

const ItemContainer = styled(KitFlexRow)`
  align-items: stretch;
`;

const ComponentContainer = styled.div`
  padding-bottom: ${constants.spacing.absolute.m}px;
  padding-top: ${constants.spacing.absolute.m}px;
`;

const LeftCol = styled(KitFlexCol)`
  float: left;
`;

const RightCol = styled(KitFlexCol)`
  padding-left: ${constants.spacing.absolute.m}px;
  padding-right: ${constants.spacing.absolute.m}px;
`;

interface KitTimelineItemProps {
  icon: string;
  timeStamp: string;
  displayLine?: boolean;
  descriptionOrChildren: ReactNode | string;
}

interface timelineItemInterface {
  icon: string;
  timestamp: string;
  descriptionOrChildren: ReactNode | string;
}

export interface KitTimeLineProps {
  timelineItems: timelineItemInterface[];
}

const KitTimelineItem: React.FC<KitTimelineItemProps> = ({
  icon,
  timeStamp,
  descriptionOrChildren,
  displayLine,
}) => {
  const themeContext = useContext(ThemeContext);
  return (
    <ItemContainer>
      <LeftCol>
        <KitIcon
          icon={icon}
          size={`${constants.iconSize.s}rem`}
          fill={themeContext.timeline.icon}
        />
        {displayLine && <VerticalLeftBorder />}
      </LeftCol>
      <RightCol>
        <Timestamp>{timeStamp}</Timestamp>
        {typeof descriptionOrChildren === 'string' ? (
          <Description>{descriptionOrChildren}</Description>
        ) : (
          <ComponentContainer>{descriptionOrChildren}</ComponentContainer>
        )}
      </RightCol>
    </ItemContainer>
  );
};

const KitTimeline: React.FC<KitTimeLineProps> = ({ timelineItems }) => {
  return (
    <KitFlexCol>
      {timelineItems.map((item, index) => (
        <KitTimelineItem
          icon={item.icon}
          timeStamp={item.timestamp}
          displayLine={!!timelineItems[index + 1]}
          descriptionOrChildren={item.descriptionOrChildren}
          key={item.timestamp}
        />
      ))}
    </KitFlexCol>
  );
};

export default KitTimeline;
